import styled from 'styled-components';
import { customMedia } from 'styles/utils';

export const SectionBannerWrapper = styled.div(
  ({ theme, paddingTop, paddingBottom }) => ({
    margin: `${theme.space[6]} auto`,
    padding: theme.space[4],
    paddingTop,
    paddingBottom,
    marginTop: '2rem',
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    boxShadow:
      'rgb(67 90 111 / 42%) 0 0 1px, rgb(67 90 111 / 30%) 0 5px 8px -4px',
    border: `1px solid ${theme.color.wfGrey500}`,
    background: theme.color.wfWhite,
    boxSizing: 'border-box',
    maxWidth: theme.layout.maxWidth,
    [`@media(max-width: ${theme.breakpoints.medium})`]: {
      marginTop: theme.space[6],
      flexDirection: 'column',
      padding: theme.space[6],
    },
  }),
);

export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  max-width: 40rem;
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const ImageWrapper = styled.div`
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${customMedia.lessThan('medium')`
    width: 200px
  `};
`;

export const HideButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  margin: ${props => props.theme.spacing.default};
  display: flex;
  flex-direction: row;
`;
